module.exports = __webpack_public_path__ + "media/ringtone.6db138bb.wav";